export const setGAContext = (context: Record<string, any>) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    console.log("GA CONTEXT SET >>>>", context);
    window.gtag("set", context);
  } else {
    console.warn("GA4 not initialized yet — context skipped:", context);
  }
};

export const sendGAEvent = (eventName: string, params: Record<string, any>) => {
  console.log("SENDING>>>>", eventName);
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  } else {
    console.warn("GA4 not initialized yet — event skipped:", eventName);
  }
};
